   <template>
<div>
       <Header/>

<!--End mainmenu area--> 

<!--Start breadcrumb area-->

<section class="breadcrumb-area" v-bind:style="{backgroundImage: 'url('+this.pagebanner+ ')' }">
	<div class="container text-center">
		<h1 v-if="pagedata">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</h1>
		<span class="border"></span>
	</div>
</section>
<!--End breadcrumb area-->
         
<!--Start breadcrumb bottom area--> 
<section class="breadcrumb-bottom-area">
    <div class="container">
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <a href="#"></a>    
        </div>
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <ul>
               <li><a :href="$i18n.locale == 'en' ? '../../../../en/': '../../../../ar/'">{{ $i18n.locale == 'en' ? 'Home':'الرئيسية' }}</a></li>
               <li>></li>
                <li><a href="#">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</a></li>

                
            </ul>    
        </div>        
    </div>    
</section>         
<section class="branch-area">
    <div class="container">
        <div class="branch-title pull-right">
                <h3 :style="$i18n.locale=='en'?'text-align: left!important':'text-align: right!important'" dir="rtl" v-html="$i18n.locale == 'en' ? pagedata.pagecontenten: pagedata.pagecontentar"> {{ $i18n.locale == 'en' ?  pagedata.pagecontenten: pagedata.pagecontentar  }}</h3>  

        </div>

        </div>
</section>
<section class="faq-content-area">
    <div class="container">
        <div class="row">
            <div class="bs-example">
                <div class="panel-group" id="accordion">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" v-html="$i18n.locale == 'en' ?contactdetails[0].titleen:contactdetails[0].titlear">{{ $i18n.locale == 'en' ?contactdetails[0].titleen:contactdetails[0].titlear}}</a>
                            </h4>
                        </div>
                        <div id="collapseTwo" class="panel-collapse collapse">
                            <div class="panel-body">
                                <div id="map-container-google-1" class="z-depth-1-half map-container" style="width:1500px;">
                                    <div class="parent">

                                        <div class=" child2">
                                           <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3476.5880825297872!2d47.984089850768!3d29.382347956411238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf84918a3d1be5%3A0x6e00fb1e0bff3c67!2sGravity%20Tower%2C%20Ahmad%20Al%20Jaber%20St%2C%20Al%20Kuwayt!5e0!3m2!1sen!2skw!4v1662471279075!5m2!1sen!2skw"
                                                frameborder="0"
                                                style="border:0;width:1180px;height:350px;" allowfullscreen></iframe>
                                        </div>
                                        <div class="child1" v-if="contactdetails">
                                            <div v-html="$i18n.locale == 'en' ?contactdetails[0].adressen:contactdetails[0].adressar" class="overlay" style="font-family: 'Montserrat', sans-serif;">
                                                                                    {{ $i18n.locale == 'en' ?contactdetails[0].adressen:contactdetails[0].adressar }}   
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapseThree" v-if="$i18n.locale == 'en' ?contactdetails[1].titleen:contactdetails[1].titlear">{{$i18n.locale == 'en' ?contactdetails[1].titleen:contactdetails[1].titlear}}</a>
                            </h4>
                        </div>
                        <div id="collapseThree" class="panel-collapse collapse">
                            <div class="panel-body">
                                <div id="map-container-google-1" class="z-depth-1-half map-container" style="width:1500px;">
                                    <div class="parent">

                                        <div class=" child2">
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3476.530347956899!2d47.98815520076801!3d29.384037756333054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf84906d01db53%3A0x849458462610c48b!2sAl-Sharq%20Tower%2C%20Ahmad%20Al%20Jaber%20St%2C%20Al%20Kuwayt!5e0!3m2!1sen!2skw!4v1662472003056!5m2!1sen!2skw"
                                                frameborder="0"
                                                style="border:0;width:1180px;height:350px;" allowfullscreen></iframe>
                                        </div>
                                        <div class="child1" v-if="contactdetails">
                                            <div v-html="$i18n.locale == 'en' ?contactdetails[1].adressen:contactdetails[1].adressar" class="overlay" style="font-family: 'Montserrat', sans-serif;">
                                                                                                                               {{ $i18n.locale == 'en' ?contactdetails[1].adressen:contactdetails[1].adressar }}   

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapse4" v-if="$i18n.locale == 'en' ?contactdetails[2].titleen:contactdetails[2].titlear">{{$i18n.locale == 'en' ?contactdetails[2].titleen:contactdetails[2].titlear}}</a>
                            </h4>
                        </div>
                        <div id="collapse4" class="panel-collapse collapse">
                            <div class="panel-body">
                                <div id="map-container-google-1" class="z-depth-1-half map-container" style="width:1500px;">
                                    <div class="parent" style="background-color: #ea3c53 !important;">

                                        <div class=" child2">
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3486.7816826946323!2d48.13166379233278!3d29.08259561371416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf0721e6d1fbbb%3A0x50cd39d09cd98b6e!2sAjial%20Complex!5e0!3m2!1sen!2skw!4v1662471583379!5m2!1sen!2skw"
                                                frameborder="0"
                                                style="border:0;width:1180px;height:350px;" allowfullscreen></iframe>
                                        </div>
<div class="child1" v-if="contactdetails">
                                            <div v-html="$i18n.locale == 'en' ?contactdetails[2].adressen:contactdetails[2].adressar" class="overlay" style="font-family: 'Montserrat', sans-serif;">
                                          {{ $i18n.locale == 'en' ?contactdetails[2].adressen:contactdetails[2].adressar }}   
                                            </div>
                                        </div>                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapse5" v-if="$i18n.locale == 'en' ?contactdetails[3].titleen:contactdetails[3].titlear">{{$i18n.locale == 'en' ?contactdetails[3].titleen:contactdetails[3].titlear}}</a>
                            </h4>
                        </div>
                        <div id="collapse5" class="panel-collapse collapse">
                            <div class="panel-body">
                                <div id="map-container-google-1" class="z-depth-1-half map-container" style="width:1500px;">
                                    <div class="parent" style="background-color: #ea3c53 !important;">

                                        <div class=" child2">
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3477.9923556079193!2d48.06915019237761!3d29.341219801482698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fcf9da8611d620b%3A0xf3726607ba49da05!2sAl%20Fanar%20Mall!5e0!3m2!1sen!2skw!4v1662471796818!5m2!1sen!2skw"
                                                frameborder="0"
                                                style="border:0;width:1180px;height:350px;" allowfullscreen></iframe>
                                        </div>
<div class="child1" v-if="contactdetails">
                                            <div v-html="$i18n.locale == 'en' ?contactdetails[3].adressen:contactdetails[3].adressar" class="overlay" style="font-family: 'Montserrat', sans-serif;">
 {{ $i18n.locale == 'en' ?contactdetails[3].adressen:contactdetails[3].adressar }}
                                            </div>
                                        </div>                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div><!--Office 1-->
        </div>
    </div>
</section>

<!--End slogan area-->
<!--Start footer area-->  

   
            <Footer/>
 </div>
    </div>
</template>

<script>
import "https://maps.googleapis.com/maps/api/js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
        return {
            langs: ['en', 'ar'],
           
            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            ceomessage: '',
            successstories: '',
            slide1image:'',
            slide2image:'',
            slide3image:'',
            techanalysis:'',
            pagedata:'',
            pagebanner:'',
            crosses:'',
            currencydata:'',
            techanalysis:'',
            contactdetails:'',
            

        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
          var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'ar';
        }
       

        this.loadpagedata('contact');
        this.loadcontact();


    },
    mounted() {
        
        this.loadpagedata('contact');
        this.loadcontact();
        this.loaddata();

    },

    methods: {
        loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {

                       
                        this.pagefooteren = res.data.sitesettings[0].pagefooteren;
                        this.pagefooterar = res.data.sitesettings[0].pagefooterar;
                      
                    }
                });
        },
        loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                          if (res.data.code == 200) {
                        this.pagedata = res.data.pagedata[0];
                        this.pagebanner=this.serverurl+'/public/pagebanners/'+res.data.pagedata[0].pagebanner;
                          }
                        else{

                            this.$router.push({ name: 'NotFound' })
                        }
                    }
                });
            

        },
         loadcontact() {

            this.$axios.get("loadcontactdata",
            )
                .then(res => {
                    if (res) {

                        this.contactdetails = res.data.contactdata;

                    }
                });
        },

    }
}
</script>
<style>
        .map-button {
            cursor: pointer;
            transition: all 0.7s;
            -webkit-transition: all 0.7s;
        }

        #google-map {
            height: 350px;
            width: 100%;
        }

        .panel-default > .panel-heading {
            color: #688ec5;
            background-color: #fffcfc;
            border-color: #ddd;
            height: 50px;
        }

        .parent {
            position: relative;
            width: 1000px;
            height: 350px;
            margin: 0px;
            background-color: #688ec5 !important;
        }

        .child1 {
            position: absolute;
            line-height:20px!important;
            top: 0;
            left: 0;
            opacity: 1;
           
            height: 350px;
            width: 350px;
            left: -1%!important;
                        background-color: #688ec5!important;

        }

        .child2 {
            z-index: 1;
            margin: 0px;
            height: 350px;
                        background-color: #ea3c53!important;

        }

    </style>
<style>
#div1::after{
    clear: none!important;
    
}
.carousel {
  background: #2f435700!important;
}
    
</style>
